// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var DateUtils = require("../../../shared/src/DateUtils.bs.js");
var MathUtils = require("../../../shared/src/MathUtils.bs.js");
var ReactUtils = require("../../../shared/src/ReactUtils.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../../../shared-browser/src/BrowserStyle.bs.js");
var PaymentUtils = require("../../../shared/src/PaymentUtils.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var BrowserComponents_Card = require("../../../shared-browser/src/components/BrowserComponents_Card.bs.js");
var BrowserComponents_Icon = require("../../../shared-browser/src/components/BrowserComponents_Icon.bs.js");
var BrowserComponents_Text = require("../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Image = require("../../../shared-browser/src/components/BrowserComponents_Image.bs.js");
var BrowserComponents_Spacer = require("../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var CommonTypes_LongPhoneNumber = require("../../../shared/src/types/CommonTypes_LongPhoneNumber.bs.js");
var CommonTypes_Shift_DressCode = require("../../../shared/src/types/CommonTypes_Shift_DressCode.bs.js");
var BrowserComponents_FlexColumn = require("../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var WebComponents_PostAShiftForm = require("./WebComponents_PostAShiftForm.bs.js");
var BrowserBindings_GoogleMapReact = require("../../../shared-browser/src/bindings/BrowserBindings_GoogleMapReact.bs.js");
var BrowserComponents_ShiftTipsIndicator = require("../../../shared-browser/src/components/BrowserComponents_ShiftTipsIndicator.bs.js");
var CommonTypes_Business_Location_ParkingCost = require("../../../shared/src/types/business/CommonTypes_Business_Location_ParkingCost.bs.js");

var card = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flexDirection(BrowserStyle.row),
      tl: {
        hd: BrowserStyle.justifyContent(BrowserStyle.center),
        tl: {
          hd: BrowserStyle.padding(BrowserStyle.zero),
          tl: /* [] */0
        }
      }
    });

var leftSide = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.flex({
              NAME: "num",
              VAL: 1.0
            }),
        tl: {
          hd: BrowserStyle.padding(BrowserStyle.Spacing.medium),
          tl: /* [] */0
        }
      }
    });

var rightSide = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.backgroundColor({
              TAG: /* Blue */0,
              _0: /* Darkest */0
            }),
        tl: {
          hd: BrowserStyle.borderBottomRightRadius(BrowserStyle.rem(0.25)),
          tl: {
            hd: BrowserStyle.borderTopRightRadius(BrowserStyle.rem(0.25)),
            tl: {
              hd: BrowserStyle.color({
                    TAG: /* White */7,
                    _0: /* Light */2
                  }),
              tl: {
                hd: BrowserStyle.display(BrowserStyle.flexBox),
                tl: {
                  hd: BrowserStyle.flexDirection(BrowserStyle.column),
                  tl: {
                    hd: BrowserStyle.justifyContent(BrowserStyle.center),
                    tl: {
                      hd: BrowserStyle.padding2(BrowserStyle.Spacing.medium, BrowserStyle.Spacing.large),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

function arg(param) {
  return BrowserStyle.withFont(param, /* Quicksand */0, /* Large */4, /* Bold */2);
}

var leftSideTitleText = Curry._1(BrowserStyle.style, Curry._1(arg(undefined), {
          hd: BrowserStyle.firstOfType({
                hd: BrowserStyle.paddingTop(BrowserStyle.zero),
                tl: /* [] */0
              }),
          tl: {
            hd: BrowserStyle.color({
                  TAG: /* Grey */2,
                  _0: /* Dark */1
                }),
            tl: {
              hd: BrowserStyle.paddingTop(BrowserStyle.rem(0.8125)),
              tl: /* [] */0
            }
          }
        }));

var leftSideSubtitleText = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, /* OpenSans */1, /* Small */2, undefined)({
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Medium */2
              }),
          tl: {
            hd: BrowserStyle.marginTop(BrowserStyle.rem(0.125)),
            tl: /* [] */0
          }
        }));

function arg$1(param, param$1, param$2) {
  return BrowserStyle.withFont(param, param$1, param$2, /* Bold */2);
}

var rightSideTitleText = Curry._1(BrowserStyle.merge, {
      hd: leftSideTitleText,
      tl: {
        hd: Curry._1(BrowserStyle.style, Curry._1(arg$1(undefined, undefined, undefined), {
                  hd: BrowserStyle.color({
                        TAG: /* White */7,
                        _0: /* Light */2
                      }),
                  tl: {
                    hd: BrowserStyle.paddingBottom(BrowserStyle.rem(0.25)),
                    tl: {
                      hd: BrowserStyle.paddingTop(BrowserStyle.rem(0.75)),
                      tl: /* [] */0
                    }
                  }
                })),
        tl: /* [] */0
      }
    });

var rightSideSubtitleText = Curry._1(BrowserStyle.merge, {
      hd: leftSideSubtitleText,
      tl: {
        hd: Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.color({
                    TAG: /* White */7,
                    _0: /* Dark */0
                  }),
              tl: {
                hd: BrowserStyle.textAlign("center"),
                tl: /* [] */0
              }
            }),
        tl: /* [] */0
      }
    });

var Styles = {
  card: card,
  leftSide: leftSide,
  rightSide: rightSide,
  leftSideTitleText: leftSideTitleText,
  leftSideSubtitleText: leftSideSubtitleText,
  rightSideTitleText: rightSideTitleText,
  rightSideSubtitleText: rightSideSubtitleText
};

function WebComponents_ProfessionalShiftPreview$TitleCard(Props) {
  var address = Props.address;
  var endDatetime = Props.endDatetime;
  var hourlyRateCents = Props.hourlyRateCents;
  var locationName = Props.locationName;
  var param = Props.shiftType;
  var startDatetime = Props.startDatetime;
  var timezone = Props.timezone;
  var tipsPayoutType = Props.tipsPayoutType;
  return React.createElement(BrowserComponents_Card.make, {
              className: card,
              children: null
            }, React.createElement("div", {
                  className: leftSide
                }, React.createElement("div", {
                      className: leftSideTitleText
                    }, React.createElement(ReactUtils.S.make, {
                          children: locationName
                        })), React.createElement("div", {
                      className: leftSideSubtitleText
                    }, React.createElement(ReactUtils.S.make, {
                          children: address
                        })), React.createElement("div", {
                      className: leftSideTitleText
                    }, React.createElement(ReactUtils.S.make, {
                          children: param.name
                        })), React.createElement("div", {
                      className: leftSideSubtitleText
                    }, React.createElement(ReactUtils.S.make, {
                          children: Relude_String.toLowerCase(DateUtils.formatDate(/* Time */14, /* Zone */{
                                      _0: timezone
                                    })(startDatetime)) + (" - " + (Relude_String.toLowerCase(DateUtils.formatDate(/* Time */14, /* Zone */{
                                          _0: timezone
                                        })(endDatetime)) + (" / " + DateUtils.formatDate(/* LongMonthDayYear */12, /* Zone */{
                                        _0: timezone
                                      })(startDatetime))))
                        }))), React.createElement("div", {
                  className: rightSide
                }, React.createElement(BrowserComponents_Icon.make, {
                      color: {
                        TAG: /* White */7,
                        _0: /* Light */2
                      },
                      icon: {
                        TAG: /* Large */0,
                        _0: {
                          TAG: /* ShiftTypeCategory */2,
                          _0: param.category
                        }
                      },
                      size: /* XLarge */4
                    }), React.createElement("div", {
                      className: rightSideTitleText
                    }, React.createElement(ReactUtils.S.make, {
                          children: MathUtils.formatCentsToMoney(hourlyRateCents) + "/hr"
                        })), React.createElement("div", {
                      className: rightSideSubtitleText
                    }, React.createElement(ReactUtils.S.make, {
                          children: "est. " + Relude_String.replaceRegex(/\.[0-9]{2}/, "", MathUtils.formatCentsToMoney(PaymentUtils.getEstimatePayoutAmountInCents(startDatetime, endDatetime, hourlyRateCents)))
                        })), typeof tipsPayoutType === "number" && tipsPayoutType !== 0 ? React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                            size: /* Small */3
                          }), React.createElement(BrowserComponents_ShiftTipsIndicator.make, {
                            theme: /* DarkBackground */1
                          })) : null));
}

var TitleCard = {
  Styles: Styles,
  make: WebComponents_ProfessionalShiftPreview$TitleCard
};

function arg$2(param) {
  return BrowserStyle.withFont(param, /* Quicksand */0, /* Medium */3, /* Bold */2);
}

var titleText = Curry._1(BrowserStyle.style, Curry._1(arg$2(undefined), {
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Dark */1
              }),
          tl: /* [] */0
        }));

var subtitleText = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, /* OpenSans */1, /* Medium */3, undefined)({
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Medium */2
              }),
          tl: {
            hd: BrowserStyle.whiteSpace("preWrap"),
            tl: /* [] */0
          }
        }));

var Styles$1 = {
  titleText: titleText,
  subtitleText: subtitleText
};

function WebComponents_ProfessionalShiftPreview$Description(Props) {
  var description = Props.description;
  return React.createElement(BrowserComponents_Card.make, {
              children: null
            }, React.createElement(BrowserComponents_Text.make, {
                  className: titleText,
                  children: "Description"
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Small */3
                }), React.createElement(BrowserComponents_Text.make, {
                  className: subtitleText,
                  children: description
                }));
}

var Description = {
  Styles: Styles$1,
  make: WebComponents_ProfessionalShiftPreview$Description
};

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display(BrowserStyle.flexBox),
      tl: {
        hd: BrowserStyle.marginBottom(BrowserStyle.rem(0.5)),
        tl: {
          hd: BrowserStyle.lastChild({
                hd: BrowserStyle.marginBottom(BrowserStyle.zero),
                tl: /* [] */0
              }),
          tl: /* [] */0
        }
      }
    });

var content = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, /* OpenSans */1, undefined, undefined)({
          hd: BrowserStyle.marginLeft(BrowserStyle.rem(1.0)),
          tl: /* [] */0
        }));

var title = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Small */2, undefined)({
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Medium */2
              }),
          tl: /* [] */0
        }));

var text = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Medium */3, undefined)({
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Dark */1
              }),
          tl: /* [] */0
        }));

var link = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.color({
            TAG: /* Grey */2,
            _0: /* Dark */1
          }),
      tl: /* [] */0
    });

var Styles$2 = {
  container: container,
  content: content,
  title: title,
  text: text,
  link: link
};

function getTextElement(text) {
  if (text.TAG === /* String */0) {
    return React.createElement(ReactUtils.S.make, {
                children: text._0
              });
  } else {
    return React.createElement("a", {
                className: link,
                href: text._1,
                target: "_blank"
              }, React.createElement(ReactUtils.S.make, {
                    children: text._0
                  }));
  }
}

function WebComponents_ProfessionalShiftPreview$Location$Row(Props) {
  var icon = Props.icon;
  var title$1 = Props.title;
  var text$1 = Props.text;
  return React.createElement("div", {
              className: container
            }, React.createElement(BrowserComponents_Icon.make, {
                  icon: {
                    TAG: /* Small */1,
                    _0: icon
                  }
                }), React.createElement("div", {
                  className: content
                }, React.createElement("div", {
                      className: title
                    }, React.createElement(ReactUtils.S.make, {
                          children: title$1
                        })), React.createElement("div", {
                      className: text
                    }, getTextElement(text$1))));
}

var Row = {
  Styles: Styles$2,
  getTextElement: getTextElement,
  make: WebComponents_ProfessionalShiftPreview$Location$Row
};

var container$1 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display(BrowserStyle.flexBox),
      tl: {
        hd: BrowserStyle.flexDirection(BrowserStyle.column),
        tl: {
          hd: BrowserStyle.padding(BrowserStyle.zero),
          tl: {
            hd: BrowserStyle.width(BrowserStyle.pct(100.0)),
            tl: /* [] */0
          }
        }
      }
    });

var map = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.height(BrowserStyle.rem(10.5625)),
      tl: {
        hd: BrowserStyle.width(BrowserStyle.pct(100.0)),
        tl: /* [] */0
      }
    });

var mapPin = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.height(BrowserStyle.rem(1.0)),
      tl: {
        hd: BrowserStyle.width(BrowserStyle.rem(1.0)),
        tl: /* [] */0
      }
    });

var bottomContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display(BrowserStyle.flexBox),
      tl: {
        hd: BrowserStyle.flexDirection(BrowserStyle.column),
        tl: {
          hd: BrowserStyle.padding2(BrowserStyle.Spacing.large, BrowserStyle.Spacing.medium),
          tl: /* [] */0
        }
      }
    });

var Styles$3 = {
  container: container$1,
  map: map,
  mapPin: mapPin,
  bottomContainer: bottomContainer
};

function getMapUrl(address, geocode) {
  return "https://www.google.com/maps/place/" + (Curry._2(Relude_Array.map, (function (prim) {
                    return encodeURIComponent(prim);
                  }), Relude_String.splitArray(" ", address)).join("+") + Relude_Option.fold("", (function (param) {
                  return "/@" + (Relude_Float.toString(param.latitude) + ("," + Relude_Float.toString(param.longitude)));
                }), geocode));
}

function WebComponents_ProfessionalShiftPreview$Location(Props) {
  var address = Props.address;
  var geocode = Props.geocode;
  var token = Props.googleMapsToken;
  var parkingCost = Props.parkingCost;
  var parkingInstructions = Props.parkingInstructions;
  return React.createElement(BrowserComponents_Card.make, {
              className: container$1,
              children: null
            }, Relude_Option.fold(null, (function (geoPoint) {
                    return React.createElement("div", {
                                className: map
                              }, React.createElement(BrowserBindings_GoogleMapReact.make, BrowserBindings_GoogleMapReact.makeProps(undefined, Caml_option.some(React.createElement(BrowserBindings_GoogleMapReact.PositionalChild.make, BrowserBindings_GoogleMapReact.PositionalChild.makeProps(geoPoint, React.createElement(BrowserComponents_Icon.make, {
                                                        icon: {
                                                          TAG: /* Small */1,
                                                          _0: {
                                                            TAG: /* Shift */6,
                                                            _0: /* Location */13
                                                          }
                                                        },
                                                        size: /* Small */1
                                                      }), undefined, undefined))), 16, token, geoPoint, undefined, undefined)));
                  }), geocode), React.createElement("div", {
                  className: bottomContainer
                }, React.createElement(WebComponents_ProfessionalShiftPreview$Location$Row, {
                      icon: {
                        TAG: /* Shift */6,
                        _0: /* Location */13
                      },
                      title: "Address",
                      text: {
                        TAG: /* Url */1,
                        _0: address,
                        _1: getMapUrl(address, geocode)
                      }
                    }), React.createElement(WebComponents_ProfessionalShiftPreview$Location$Row, {
                      icon: {
                        TAG: /* Shift */6,
                        _0: /* Car */5
                      },
                      title: "Parking Cost",
                      text: {
                        TAG: /* String */0,
                        _0: CommonTypes_Business_Location_ParkingCost.toDisplayString(parkingCost)
                      }
                    }), React.createElement(WebComponents_ProfessionalShiftPreview$Location$Row, {
                      icon: {
                        TAG: /* Shift */6,
                        _0: /* Clipboard */8
                      },
                      title: "Arrival Instructions",
                      text: {
                        TAG: /* String */0,
                        _0: parkingInstructions
                      }
                    })));
}

var $$Location = {
  Row: Row,
  Styles: Styles$3,
  getMapUrl: getMapUrl,
  make: WebComponents_ProfessionalShiftPreview$Location
};

function arg$3(param, param$1) {
  return BrowserStyle.withFont(param, /* Quicksand */0, param$1, /* Bold */2);
}

var cardTitle = Curry._1(BrowserStyle.style, Curry._1(arg$3(undefined, undefined), /* [] */0));

var image = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.height(BrowserStyle.rem(3.0)),
      tl: {
        hd: BrowserStyle.width(BrowserStyle.rem(2.5)),
        tl: /* [] */0
      }
    });

function arg$4(param, param$1) {
  return BrowserStyle.withFont(param, /* Quicksand */0, param$1, /* Bold */2);
}

var dressCodeTitle = Curry._1(BrowserStyle.style, Curry._1(arg$4(undefined, undefined), /* [] */0));

var title$1 = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Small */2, undefined)({
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Medium */2
              }),
          tl: /* [] */0
        }));

var Styles$4 = {
  cardTitle: cardTitle,
  image: image,
  dressCodeTitle: dressCodeTitle,
  title: title$1
};

function WebComponents_ProfessionalShiftPreview$Attire(Props) {
  var accessories = Props.accessories;
  var attire = Props.attire;
  var dressCode = Props.dressCode;
  return React.createElement(BrowserComponents_Card.make, {
              children: null
            }, React.createElement(BrowserComponents_Text.make, {
                  className: cardTitle,
                  children: "Attire"
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_FlexRow.make, {
                  children: null
                }, React.createElement(BrowserComponents_Image.make, {
                      className: image,
                      image: {
                        TAG: /* Illustration */1,
                        _0: {
                          TAG: /* DressCode */0,
                          _0: dressCode
                        }
                      }
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Medium */4
                    }), React.createElement(BrowserComponents_FlexColumn.make, {
                      children: null
                    }, React.createElement(BrowserComponents_Text.make, {
                          className: dressCodeTitle,
                          children: CommonTypes_Shift_DressCode.toString(dressCode)
                        }), React.createElement(BrowserComponents_Spacer.make, {
                          size: /* XSmall */2
                        }), React.createElement(BrowserComponents_Text.make, {
                          children: Relude_Option.getOrElse("", CommonTypes_Shift_DressCode.getDescription(dressCode))
                        }), Relude_Option.fold(false, Relude_String.isNonWhitespace, attire) ? React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                                size: /* Small */3
                              }), React.createElement(BrowserComponents_Text.make, {
                                className: title$1,
                                children: "Special Notes & Instructions"
                              }), React.createElement(BrowserComponents_Text.make, {
                                children: Relude_Option.getOrElse("", attire)
                              })) : null, Relude_Array.isNotEmpty(accessories) ? React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                                size: /* Small */3
                              }), React.createElement(BrowserComponents_Text.make, {
                                className: title$1,
                                children: "Accessories"
                              }), React.createElement(BrowserComponents_Text.make, {
                                children: Curry._3(Relude_Array.foldLeft, (function (prim, prim$1) {
                                        return prim + prim$1;
                                      }), "", Relude_Array.intersperse(", ", Curry._2(Relude_Array.map, (function (param) {
                                                return param.name;
                                              }), accessories)))
                              })) : null)));
}

var Attire = {
  Styles: Styles$4,
  make: WebComponents_ProfessionalShiftPreview$Attire
};

function arg$5(param, param$1) {
  return BrowserStyle.withFont(param, /* Quicksand */0, param$1, /* Bold */2);
}

var title$2 = Curry._1(BrowserStyle.style, Curry._1(arg$5(undefined, undefined), /* [] */0));

function arg$6(param, param$1) {
  return BrowserStyle.withFont(param, /* Quicksand */0, param$1, /* Bold */2);
}

var name = Curry._1(BrowserStyle.style, Curry._1(arg$6(undefined, undefined), /* [] */0));

var phoneNumber = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.color({
            TAG: /* Grey */2,
            _0: /* Medium */2
          }),
      tl: /* [] */0
    });

var Styles$5 = {
  title: title$2,
  name: name,
  phoneNumber: phoneNumber
};

function WebComponents_ProfessionalShiftPreview$OnsiteManager(Props) {
  var param = Props.onsiteManager;
  return React.createElement(BrowserComponents_Card.make, {
              children: null
            }, React.createElement(BrowserComponents_Text.make, {
                  className: title$2,
                  children: "Onsite Manager"
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_FlexRow.make, {
                  children: null
                }, React.createElement(BrowserComponents_Icon.make, {
                      icon: {
                        TAG: /* Small */1,
                        _0: {
                          TAG: /* Navigation */5,
                          _0: /* Profile */8
                        }
                      },
                      size: /* Large */3
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Medium */4
                    }), React.createElement(BrowserComponents_FlexColumn.make, {
                      children: null
                    }, React.createElement(BrowserComponents_Text.make, {
                          className: name,
                          children: param.name
                        }), React.createElement(BrowserComponents_Text.make, {
                          className: phoneNumber,
                          children: CommonTypes_LongPhoneNumber.toFormattedString(param.phoneNumber)
                        }))));
}

var OnsiteManager = {
  Styles: Styles$5,
  make: WebComponents_ProfessionalShiftPreview$OnsiteManager
};

var container$2 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.padding2(BrowserStyle.Spacing.large, BrowserStyle.Spacing.xxLarge),
      tl: /* [] */0
    });

var previewContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.padding(BrowserStyle.Spacing.medium),
      tl: /* [] */0
    });

var Styles$6 = {
  container: container$2,
  previewContainer: previewContainer
};

function WebComponents_ProfessionalShiftPreview(Props) {
  var accessories = Props.accessories;
  var address = Props.address;
  var attire = Props.attire;
  var className = Props.className;
  var description = Props.description;
  var dressCode = Props.dressCode;
  var endDatetime = Props.endDatetime;
  var geocode = Props.geocode;
  var googleMapsToken = Props.googleMapsToken;
  var hourlyRateCents = Props.hourlyRateCents;
  var locationName = Props.locationName;
  var onsiteManager = Props.onsiteManager;
  var parkingCost = Props.parkingCost;
  var parkingInstructions = Props.parkingInstructions;
  var shiftType = Props.shiftType;
  var startDatetime = Props.startDatetime;
  var timezone = Props.timezone;
  var tipsPayoutType = Props.tipsPayoutType;
  var tmp = {
    address: address,
    googleMapsToken: googleMapsToken,
    parkingCost: parkingCost,
    parkingInstructions: parkingInstructions
  };
  if (geocode !== undefined) {
    tmp.geocode = Caml_option.valFromOption(geocode);
  }
  return React.createElement(BrowserComponents_FlexColumn.make, {
              className: BrowserStyle.Utils.extendBaseStyle(container$2, className),
              children: null
            }, React.createElement(WebComponents_PostAShiftForm.Title.make, {
                  subtitle: "See what your shift looks like in the Professionals app.",
                  title: "What Professionals See"
                }), React.createElement("div", {
                  className: previewContainer
                }, React.createElement(WebComponents_ProfessionalShiftPreview$TitleCard, {
                      address: address,
                      endDatetime: endDatetime,
                      hourlyRateCents: hourlyRateCents,
                      locationName: locationName,
                      shiftType: shiftType,
                      startDatetime: startDatetime,
                      timezone: timezone,
                      tipsPayoutType: tipsPayoutType
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Large */5
                    }), React.createElement(WebComponents_ProfessionalShiftPreview$Description, {
                      description: description
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Large */5
                    }), React.createElement(WebComponents_ProfessionalShiftPreview$Location, tmp), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Large */5
                    }), React.createElement(WebComponents_ProfessionalShiftPreview$Attire, {
                      accessories: accessories,
                      attire: attire,
                      dressCode: dressCode
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Large */5
                    }), React.createElement(WebComponents_ProfessionalShiftPreview$OnsiteManager, {
                      onsiteManager: onsiteManager
                    })));
}

var make = WebComponents_ProfessionalShiftPreview;

exports.TitleCard = TitleCard;
exports.Description = Description;
exports.$$Location = $$Location;
exports.Attire = Attire;
exports.OnsiteManager = OnsiteManager;
exports.Styles = Styles$6;
exports.make = make;
/* card Not a pure module */
